import { AppBar, Box, Toolbar } from "@mui/material";
import React from "react";
import Logo from "../../atoms/Logo/Logo";

interface NavbarProps {
  onUsuarios: () => void;
  onConfig: () => void;
  selected?: "usuarios" | "config";
}

const Navbar: React.FC<NavbarProps> = ({}) => (
  <AppBar
    sx={{
      background: "transparent",
      color: "#222",
      boxShadow: "0 1px 8px rgba(0,0,0,0.04)",
    }}
  >
    <Toolbar sx={{ justifyContent: "center", minHeight: 48 }}>
      <Box>
        <Logo width={250} height={100} />
      </Box>
    </Toolbar>
  </AppBar>
);

export default Navbar;
